import { sha256 } from 'js-sha256';

import { fg } from '@atlaskit/platform-feature-flags';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

/**
 * Strip highlight markers from text
 */
export const cleanExcerpt = (text: string) =>
	text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');

// copied over from @confluence/hash
const hash = (data: any, asBytes: boolean = false) => {
	const hash = sha256.create();
	hash.update(data);
	if (asBytes) {
		return hash.array();
	}
	return hash.hex();
};

export const hashDataAsByte = (data: any) => {
	return hash(data, true) as number[];
};

export const hashData = (data: any) => {
	return hash(data) as string;
};

// TODO: Remove this once each product passes this value via the generateUserUrl prop
export const getUserPath = (
	userId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => {
	if (primaryProduct === 'confluence') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'USER',
					payload: {
						userId,
					},
					cloudId,
					hostProduct: 'confluence',
				}).href
			: `/wiki/people/${userId}`;
	} else if (primaryProduct === 'townsquare') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'USER',
					payload: {
						userId,
					},
					cloudId,
					hostProduct: 'home',
				}).href
			: `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
	}
};

// TODO: Remove this once each product passes this value via the generateTeamUrl prop
export const getTeamPath = (
	teamId: string,
	primaryProduct: string,
	orgId: string,
	cloudId: string,
) => {
	if (primaryProduct === 'confluence') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'TEAM',
					payload: {
						teamId,
					},
					cloudId,
					hostProduct: 'confluence',
				}).href
			: `/wiki/people/team/${teamId}`;
	} else if (primaryProduct === 'townsquare') {
		return fg('platform-adopt-teams-nav-config')
			? navigateToTeamsApp({
					type: 'TEAM',
					payload: {
						teamId,
					},
					cloudId,
				}).href
			: `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
	}
};
